module.exports = __webpack_public_path__ + "img/profile-circle-white-20x20.504b3f00.svg";